import Router, { Resource } from "tg-resources";
import {getCookie} from 'utils/cookie';


const api = new Router({
    stops: new Resource('stops/'),
    routes: new Resource('routes/'),
    quickDeps: new Resource('quick-deps/'),
    trafiDepartures: new Resource('trafi-departures/'),
    timetable: new Resource('timetable/'),
    upcoming: new Resource('upcoming/'),
    stopTimes: new Resource('stoptimes/'),
    live: new Resource('live/'),
    trip: new Resource('trip/${pk}/'),
}, {
    apiRoot: `${DJ_CONST.SITE_URL}/api/`,
    headers: () => ({
        Accept: 'application/json',
        'X-CSRFToken': getCookie('csrftoken'),
    }),
});

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js